var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58302",
    "data-name": "Group 58302",
    transform: "translate(-1143 -102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7807",
    "data-name": "Rectangle 7807",
    d: "M0,0H21A20,20,0,0,1,41,20V41a0,0,0,0,1,0,0H20A20,20,0,0,1,0,21V0A0,0,0,0,1,0,0Z",
    transform: "translate(1143 102)",
    fill: "#3ea598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42188",
    "data-name": "Path 42188",
    d: "M12.429,5.51a1.278,1.278,0,0,0-1.281,1.281h0v4.352H6.781A1.265,1.265,0,0,0,5.5,12.423a1.3,1.3,0,0,0,1.281,1.3h4.367v4.367a1.281,1.281,0,0,0,2.562,0h0V13.719h4.382a1.3,1.3,0,0,0,1.281-1.3,1.278,1.278,0,0,0-1.281-1.281H13.709V6.791A1.278,1.278,0,0,0,12.429,5.51Z",
    transform: "translate(1145.911 122.498) rotate(-45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d33fe726cf2f23b4ea09cbc8beace908.svg";
export { ForwardRef as ReactComponent };